import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-1SMD5",
  "use": "left-1SMD5-usage",
  "viewBox": "0 0 4 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 9\" id=\"left-1SMD5\"><path fill-rule=\"evenodd\" d=\"M0 4.5L4 0v9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol